<template>
  <div>
    <page-header title="Account Profile" breadcrumb="Dashboard >> Settings >> Account Profile" />
    <div class="flex justify-between mt-12 mb-2">
      <div class="flex">
        <div class="tab-item" :class="{ active: currentTab == 'account-owner' }" @click="currentTab = 'account-owner'">
          <p>Account Owner</p>
        </div>
        <div class="tab-item" :class="{ active: currentTab == 'oganization-information' }"
          @click="currentTab = 'oganization-information'">
          <p>Organization Information</p>
        </div>
        <div class="tab-item" :class="{ active: currentTab == 'know-your-customer' }"
          @click="currentTab = 'know-your-customer'">
          <p>Know Your Customer (KYC)</p>
        </div>
      </div>
    </div>
    <hr class=" mb-2" />
    <keep-alive>
      <component :is="currentTab"></component>
    </keep-alive>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import AccountOwner from "./Tabs/AccountOwner";
import OganizationInformation from "./Tabs/OganizationInformation";
import KnowYourCustomer from "./Tabs/kyc/KnowYourCustomer.vue";
import Users from "@/components/3pl/Users/Tabs/Users";
export default {
  components: {
    OganizationInformation,
    AccountOwner,
    KnowYourCustomer,
    Users,
    PageHeader,
  },
  data() {
    return {
      currentTab: "account-owner",
      query: "",
      count: {},
    };
  },
  watch: {
    currentTab(val) {
      this.$store.dispatch("setCurrentUsersAndGroupTab", val);
    },
  },
  mounted() {
    const currentTab = this.$store.getters.currentUserAndGroupsTab;
    if (currentTab) {
      this.currentTab = currentTab;
    }
  },
  methods: {
    showDeleteModal(payload) {
      this.itemToDelete = payload[0];
      this.selectedId = payload[1];
      this.isDeleteModal = true;
    },
    async deleteUser() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteUser(this.selectedId);
        this.onDeleteUser(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteGroup() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteGroup(this.selectedId);
        this.onDeleteGroup(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    onDeleteUser(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      this.$refs.usersDataTable.getAllUsers();
      this.generateToast("User successfully deleted!", "success");
    },
    onDeleteGroup(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      // this.fetchGroups = true;
      this.$refs.groupsDataTable.getAllGroups();
      this.generateToast("Group successfully deleted!", "success");
    },
    deleteItem() {
      if (this.itemToDelete == "User") {
        this.deleteUser();
      } else if (this.itemToDelete == "Group") {
        this.deleteGroup();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;
  // margin-right: 1rem;
  color: #5e646d;
  padding: 0.5rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>
